import React from 'react';
import styled from 'styled-components';
import ToggleBar from './reusableObjects/ToggleBar';
import { factors } from '../Content'
import { Math } from 'core-js';


export const ContributingFactorsDesktop1 = ({ children }) => {
  return (
    <SContributingFactors>
      <ToggleBar>
        {factors.map(list => (
          <div key={Math.random()}>
            <ul>
            {list.map(item => (
              <li key={Math.random()}>{item}</li>
            ))}
            </ul>
          </div>
        ))}
      </ToggleBar>
    </SContributingFactors>
  );
};

export const ContributingFactorsDesktop2 = ({ children }) => {
  return (
    <SContributingFactors>
      <ToggleBar>
        <div>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima enim excepturi dicta modi impedit assumenda magni illum velit consectetur quo illo eveniet harum, repellat nihil vitae quod mollitia iste. Exercitationem?</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima enim excepturi dicta modi impedit assumenda magni illum velit consectetur quo illo eveniet harum, repellat nihil vitae quod mollitia iste. Exercitationem?</p>
        </div>
      </ToggleBar>
    </SContributingFactors>
  );
};

export const ContributingFactorsMobileRow1 = ({ children }) => {
  return (
    <SContributingFactors>
      <ToggleBar>
        <div>
          <ul>
            {factors[0].map(item => (
              <li key={Math.random()}>{item}</li>
            ))}
          </ul>
        </div>
        <div>
          <ul>
            {factors[1].map(item => (
              <li key={Math.random()}>{item}</li>
            ))}
          </ul>
        </div>
      </ToggleBar>
    </SContributingFactors>
  );
};

export const ContributingFactorsMobileRow2 = ({ children }) => {
  return (
    <SContributingFactors>
      <ToggleBar>
        <div>
          <ul>
            {factors[2].map(item => (
              <li key={Math.random()}>{item}</li>
            ))}
          </ul>
        </div>
        <div>
        <ul>
          {factors[3].map(item => (
            <li key={Math.random()}>{item}</li>
          ))}
          </ul>
        </div>
      </ToggleBar>
    </SContributingFactors>
  );
}


export const SContributingFactors = styled.div`
  width: 100%;
`;
